// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"5ebe3fbd","453":"c7e6b83c","457":"ff71c5e9"}[chunkId] + ".chunk.js";
};